export const ShareIcon = ()=>{
    return (
        <svg width="1.5em" height="1.5em"  style={{margin:"0 .5rem"}} viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m20 12l-6.4-7v3.5C10.4 8.5 4 10.6 4 19c0-1.167 1.92-3.5 9.6-3.5V19l6.4-7z"></path></svg>
    )
}